import './spinner.scss';

// Assets
import { ReactComponent as SpinnerSVG } from '../../assets/spinner.svg';
import { HTMLAttributes } from 'react';

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
	color?: string;
}

const Spinner: React.FunctionComponent<SpinnerProps> = ({ color = 'gray', ...props }) => {
	return (
		<div className="spinner" {...props}>
			<SpinnerSVG ref={ref => ref?.querySelector('path')?.setAttribute('stroke', color)} />
		</div>
	);
};

export default Spinner;
